import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, FormArray, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { RptFillAlllDDlserviceService } from 'src/app/Shared/Services/rpt-fill-alll-ddlservice.service';
import { ToastrService } from 'ngx-toastr';

declare var $: any;
@Component({
  selector: 'app-rpt-bidding-live',
  templateUrl: './rpt-bidding-live.component.html',
  styleUrls: ['./rpt-bidding-live.component.css']
})
export class RptBiddingLiveComponent implements OnInit {

  FrmRptBidding: FormGroup; loginlist: any = [];
  ddlAuctionNoList: any = []; _filterAuctionList: any = []; ddlAuctionNoListNew: any = [];

  FromDate: any; ToDate: any;

  constructor(private fb: FormBuilder, private MsgService: ToastrService, private router: Router,
    private RptFillAlllDDlService: RptFillAlllDDlserviceService) {
    this.CreateFrmRptAuction();

  }
  ngOnInit() {
    this.FillAllDDL()
  }
  CreateFrmRptAuction() {
    this.FrmRptBidding = this.fb.group({
      ddlAuctionNo: [''],
    })
  }

  FillAllDDL() {
    let Ind = 1;
    let ResponseDecrpt = sessionStorage.getItem('loginSession');
    let loginlist = JSON.parse(window.atob(ResponseDecrpt));
    let OrgCode = loginlist[0]['OrgCode'];
    let CityCode = loginlist[0]['CityCode'];
    this.RptFillAlllDDlService.FillAllddl(Ind, OrgCode, CityCode).subscribe(respdata => {

      if (respdata != "" && respdata.SuccessCD == 1) {
        if (respdata.RespData.Table.length > 0) {
          this.ddlAuctionNoList = respdata.RespData.Table9
          this._filterAuctionList = this.ddlAuctionNoList.slice();
        }
      }
      else {
        if (respdata != "" && respdata.SuccessCD == 0) {
          this.MsgService.warning(respdata.MsgDesc);
        }
        else { this.MsgService.error('Not Found'); }
      }

      // let Zone=loginlist[0]['ZoneCode'];
      // let UserLevelId=loginlist[0]['UserLevelId'];
      // if(UserLevelId>2)
      // {
      //   this.FrmRptBidding.controls['ddlZone'].setValue(Zone);
      //   this.FrmRptBidding.controls['ddlZone'].disable();
      // }else
      // {
      //   this.FrmRptBidding.controls['ddlZone'].enable();
      // }
    })
  }

  OnBiddingPreview() {

    this.ddlAuctionNoListNew = [];
    let AuctionNo = this.FrmRptBidding.controls['ddlAuctionNo'].value;
    if (AuctionNo != "" && AuctionNo != "0") {
      this.ddlAuctionNoListNew = this.ddlAuctionNoList.filter(m => m.AuctionNo == AuctionNo);

      if (this.ddlAuctionNoListNew.length > 0) {
        AuctionNo = this.ddlAuctionNoListNew[0]['AuctionId'];
      }
      else {
        this.MsgService.error("This AuctionNo does not exits");
        return false;
      }
    }
    let ResponseDecrpt = sessionStorage.getItem('loginSession');
    this.loginlist = JSON.parse(window.atob(ResponseDecrpt));
    let OrgCode = this.loginlist[0]['OrgCode'];
    let CityCode = this.loginlist[0]['CityCode'];

    this.FromDate = "";
    this.ToDate = "";
    //let Heading = 'Jaipur Municiple Corporation';
    let Heading = this.loginlist[0]['ReportHeading'];
    let ReportHeading = 'Live Bidding Report';

    //window.open(`http://localhost:58298/RptBiddingLive.aspx?Ind=3&OrgCode=` + OrgCode + `&CityCode=` + CityCode + `&AuctionNo=` + AuctionNo + `&ReportHeading=` + ReportHeading + `&Heading=` + Heading + `&ReportName=RptBiddingLive`);
    //window.open(`http://115.124.113.64/JMCEAuctionReportSource/RptBidding.aspx?Ind=1&OrgCode=` + OrgCode + `&CityCode=` + CityCode + `&AuctionNo=` + AuctionNo + `&AuctionTypecd=` + AuctionType + `&ActiveInd=` + Status + `&Zone=` + Zone + `&DateFrom=` + this.FromDate + `&DateTo=` + this.ToDate + `&ReportHeading=` + ReportHeading + `&Heading=` + Heading + `&ReportName=RptAuction`);
    // window.open(`http://oswalapp.centralindia.cloudapp.azure.com/JMCEAuctionReportViewerSource/RptBiddingLive.aspx?Ind=3&OrgCode=` + OrgCode + `&CityCode=` + CityCode + `&AuctionNo=` + AuctionNo + `&DateFrom=` + this.FromDate + `&DateTo=` + this.ToDate + `&ReportHeading=` + ReportHeading + `&Heading=` + Heading + `&ReportName=RptBiddingLive`);
    window.open(`http://oswalapp.centralindia.cloudapp.azure.com/JMCEAuctionReportViewerSource/RptBiddingLive.aspx?Ind=3&OrgCode=` + OrgCode + `&CityCode=` + CityCode + `&AuctionNo=` + AuctionNo + `&ReportHeading=` + ReportHeading + `&Heading=` + Heading + `&ReportName=RptBiddingLive`);

  }

  OnClear() {

    this.FrmRptBidding.controls['ddlAuctionNo'].setValue('');

  }

  onAuctionChange(name: string) {
    this._filterAuctionList = this._myFilter(name);

  }
  private _myFilter(name: string): any[] {
    if (name) {
      return this.ddlAuctionNoList
        .filter(group => group.AuctionNo.toLowerCase().includes(name.toLowerCase()));
    }
    return this.ddlAuctionNoList;
  }
}